import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyDolphinMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#eaf8ff" />
      <path d="M120 660 C220 520, 574 520, 674 660 C594 700, 294 700, 120 660 Z" fill="#6bb7d6" />
      <circle cx={520} cy={560} r={18} fill="#034" />
      <g className="mode-copy" transform="translate(48,840)" fill="#012"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyDolphinMode;
